// extracted by mini-css-extract-plugin
export default {"overlayHeaderTitle":"CustomPropertyStringEditor-module__overlayHeaderTitle--e8XcQ","anchorButton":"CustomPropertyStringEditor-module__anchorButton--RUSPn"};